import styled from "styled-components";

export const MicroHeaderXS = styled.h6`
  font-family: ${({ theme }) => theme.fonts.microXSHeader.family};
  font-size: ${({ theme }) => theme.fonts.microXSHeader.fontSize};
  line-height: ${({ theme }) => theme.fonts.microXSHeader.lineHeight};
  font-weight: ${({ theme }) => theme.fonts.microXSHeader.fontWeight};
  letter-spacing: ${({ theme }) => theme.fonts.microXSHeader.letterSpacing};
  max-width: ${({ theme }) => theme.copyMaxWidth};
  color: ${({ theme }) => theme.colors.typographyDefault};
  margin: 0;
`;
